import { render } from "./HeroContainer.vue?vue&type=template&id=4dbbe4ac&scoped=true"
import script from "./HeroContainer.vue?vue&type=script&lang=js"
export * from "./HeroContainer.vue?vue&type=script&lang=js"

import "./HeroContainer.vue?vue&type=style&index=0&id=4dbbe4ac&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbbe4ac"]])

export default __exports__